export interface IFile {
    id: string;
    filename?: string;
    type?: string;
}

export interface ILoadingFile {
    filename: string;
    type: string;
    preview: string;
}

export enum EUploadStatus {
    UnUploaded = "Tallentamaton",
    Uploading = "Tallennetaan",
    Done = "Tallennettu",
    Removing = "Poistetaan",
    UploadError = "Epäonnistui",
    RemoveError = "Epäonnistui"
}

export interface IFileObj {
    id: string;
    name?: string;
    guid?: string
    file?: File;
    info?: any
    preview?: string;
    status: EUploadStatus

}
